import { styled } from '@mui/system';
import { theme } from 'oems/theme';

export const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Section = styled('section')`
  margin: 0 -24px;
  padding: 24px;
  border-bottom: 1px solid ${theme.palette.border.light};

  &:last-of-type {
    border-bottom: none;
    padding-bottom: 0;
  }
`;

export const Header = styled('div')`
  font-weight: 700;
  font-size: 18px;
  line-height: 125%;
  color: ${theme.palette.text.dark};
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: ${theme.breakpoints.values.sm}px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const Title = styled('h3')`
  margin-bottom: 20px;
  font-weight: 700;
  font-size: 16px;
  line-height: 125%;
  color: ${theme.palette.text.dark};
`;

export const Actions = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;

  .saveWrapper {
    display: flex;
    align-items: center;

    .tooltipIcon {
      width: 24px;
      height: 24px;
      color: ${theme.palette.secondary.main};
      margin-right: 16px;
    }
  }
`;
